import { render, staticRenderFns } from "./ProjectViewViolations.vue?vue&type=template&id=30447411&scoped=true&"
import script from "./ProjectViewViolations.vue?vue&type=script&lang=js&"
export * from "./ProjectViewViolations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectViewViolations.vue?vue&type=style&index=0&id=30447411&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30447411",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VRow,VSpacer})
